"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrcadDsnCfbTypes = exports.OrcadDsnCfbStreamUtils = exports.OrcadDsnCfbRecordDecoders = exports.parseOrCadDsnCfbLogicalSchema = exports.OrcadDsnCfbLogicalSchemaConverter = exports.convertOrCadDsnCfbToLogicalSchema = exports.OrcadDsnCfbDeclarativeSpecs = exports.readOrCadDsnCfbEntries = void 0;
exports.parseOrCadDsnCfb = parseOrCadDsnCfb;
const OrcadDsnCfbCfb_1 = require("./OrcadDsnCfbCfb");
const OrcadDsnCfbMaterializer_1 = require("./OrcadDsnCfbMaterializer");
const OrcadDsnCfbOccurrenceOwnership_1 = require("./OrcadDsnCfbOccurrenceOwnership");
const OrcadDsnCfbStreamParsing_1 = require("./OrcadDsnCfbStreamParsing");
const DsnCfbBinarySpec_1 = require("./DsnCfbBinarySpec");
const OrcadDsnCfbStreamSpecs_1 = require("./OrcadDsnCfbStreamSpecs");
const OrcadDsnCfbRecordDecoders_1 = require("./OrcadDsnCfbRecordDecoders");
const OrcadDsnCfbTypes_1 = require("./OrcadDsnCfbTypes");
const OrcadDsnCfbStreamUtils_1 = require("./OrcadDsnCfbStreamUtils");
var OrcadDsnCfbCfb_2 = require("./OrcadDsnCfbCfb");
Object.defineProperty(exports, "readOrCadDsnCfbEntries", { enumerable: true, get: function () { return OrcadDsnCfbCfb_2.readOrCadDsnCfbEntries; } });
var OrcadDsnCfbDeclarativeSpecs_1 = require("./OrcadDsnCfbDeclarativeSpecs");
Object.defineProperty(exports, "OrcadDsnCfbDeclarativeSpecs", { enumerable: true, get: function () { return OrcadDsnCfbDeclarativeSpecs_1.OrcadDsnCfbDeclarativeSpecs; } });
var OrcadDsnCfbLogicalSchemaConverter_1 = require("./OrcadDsnCfbLogicalSchemaConverter");
Object.defineProperty(exports, "convertOrCadDsnCfbToLogicalSchema", { enumerable: true, get: function () { return OrcadDsnCfbLogicalSchemaConverter_1.convertOrCadDsnCfbToLogicalSchema; } });
Object.defineProperty(exports, "OrcadDsnCfbLogicalSchemaConverter", { enumerable: true, get: function () { return OrcadDsnCfbLogicalSchemaConverter_1.OrcadDsnCfbLogicalSchemaConverter; } });
Object.defineProperty(exports, "parseOrCadDsnCfbLogicalSchema", { enumerable: true, get: function () { return OrcadDsnCfbLogicalSchemaConverter_1.parseOrCadDsnCfbLogicalSchema; } });
var OrcadDsnCfbRecordDecoders_2 = require("./OrcadDsnCfbRecordDecoders");
Object.defineProperty(exports, "OrcadDsnCfbRecordDecoders", { enumerable: true, get: function () { return OrcadDsnCfbRecordDecoders_2.OrcadDsnCfbRecordDecoders; } });
var OrcadDsnCfbStreamUtils_2 = require("./OrcadDsnCfbStreamUtils");
Object.defineProperty(exports, "OrcadDsnCfbStreamUtils", { enumerable: true, get: function () { return OrcadDsnCfbStreamUtils_2.OrcadDsnCfbStreamUtils; } });
var OrcadDsnCfbTypes_2 = require("./OrcadDsnCfbTypes");
Object.defineProperty(exports, "OrcadDsnCfbTypes", { enumerable: true, get: function () { return OrcadDsnCfbTypes_2.OrcadDsnCfbTypes; } });
function collectKnownSpecialCacheSymbolNames(entries, diagnostics) {
    const cacheEntry = entries.find((entry) => entry.type === 2 &&
        entry.content &&
        DsnCfbBinarySpec_1.DsnCfbBinarySpec.matchStreamSpecs(OrcadDsnCfbStreamSpecs_1.ORCAD_DSN_CFB_STREAM_SPECS, entry).some((spec) => spec.name === 'cache'));
    if (!cacheEntry?.content) {
        return new Map();
    }
    const decodedSymbols = OrcadDsnCfbRecordDecoders_1.OrcadDsnCfbRecordDecoders.decodeOrCadDsnCfbSymbolObjects(cacheEntry.content, {
        streamPath: cacheEntry.path,
        streamName: cacheEntry.name,
        includeDiagnostics: true,
    });
    const decodedPrimitives = OrcadDsnCfbRecordDecoders_1.OrcadDsnCfbRecordDecoders.decodeOrCadDsnCfbPrimitiveRecords(cacheEntry.content, {
        streamPath: cacheEntry.path,
        streamName: cacheEntry.name,
        includeDiagnostics: true,
    });
    const symbolObjects = decodedSymbols.records;
    const primitives = decodedPrimitives.records;
    const decodeFailureOffsets = [...(decodedSymbols.diagnostics ?? []), ...(decodedPrimitives.diagnostics ?? [])]
        .map((diagnostic) => diagnostic.offset)
        .filter((offset) => offset !== undefined)
        .sort((left, right) => left - right);
    const combined = [
        ...symbolObjects.map((record) => ({
            offset: record.offset,
            kind: record.kind,
            name: 'name' in record ? record.name : undefined,
            pinDisplayFlags: record.kind === 'symbol-pin' ? record.displayFlags : undefined,
            pinType: record.kind === 'symbol-pin' ? record.pinType : undefined,
        })),
        ...primitives.map((record) => ({ offset: record.offset, kind: record.kind, name: undefined })),
    ].sort((left, right) => left.offset - right.offset);
    const namedRecordEvidence = new Map();
    const directionVotes = new Map();
    const packageNames = new Set();
    let currentHeaderKind;
    let currentHeaderName;
    let currentHeaderOffset = 0;
    let currentBodyPinCount = 0;
    let currentBodyDirectedPins = 0;
    let currentBodyDirectionlessPins = 0;
    let currentBodyHasPowerPin = false;
    const flushCurrentGroup = (groupEndOffset) => {
        if (currentHeaderKind === 'named-record' && currentHeaderName !== undefined) {
            const decodeIncomplete = decodeFailureOffsets.some((offset) => offset >= currentHeaderOffset && offset < groupEndOffset);
            const previous = namedRecordEvidence.get(currentHeaderName);
            const statesDirection = !decodeIncomplete && currentBodyDirectedPins + currentBodyDirectionlessPins > 0;
            if (!statesDirection && currentBodyPinCount > 0) {
                diagnostics?.push({
                    severity: 'info',
                    code: 'cache-symbol-direction-unread',
                    message: `cache group named "${currentHeaderName}" states no readable pin direction, so it does not settle the connector kind`,
                    streamPath: cacheEntry.path,
                    offset: currentHeaderOffset,
                });
            }
            const votes = directionVotes.get(currentHeaderName) ?? { directed: false, undirected: false };
            if (statesDirection) {
                votes.directed = votes.directed || currentBodyDirectedPins > 0;
                votes.undirected = votes.undirected || currentBodyDirectedPins === 0;
            }
            directionVotes.set(currentHeaderName, votes);
            const currentBodyHasDirectedPin = currentBodyDirectedPins > 0;
            const drawsAPin = currentBodyPinCount > 0;
            const previousDrawsAPin = (previous?.pinCount ?? 0) > 0;
            const disagrees = drawsAPin &&
                previousDrawsAPin &&
                (previous?.hasDirectedConnectionPin !== currentBodyHasDirectedPin ||
                    previous?.hasPowerConnectionPin !== currentBodyHasPowerPin);
            namedRecordEvidence.set(currentHeaderName, {
                pinCount: Math.max(previous?.pinCount ?? 0, currentBodyPinCount),
                decodeIncomplete: (previous?.decodeIncomplete ?? true) && decodeIncomplete,
                hasDirectedConnectionPin: votes.directed,
                directionConflicted: votes.directed && votes.undirected,
                hasPowerConnectionPin: drawsAPin && !previousDrawsAPin ? currentBodyHasPowerPin : ((previous?.hasPowerConnectionPin ?? currentBodyHasPowerPin)),
                conflictingDefinitions: (previous?.conflictingDefinitions ?? false) || disagrees,
            });
        }
        else if (currentHeaderKind === 'view-header' && currentHeaderName !== undefined) {
            packageNames.add(currentHeaderName);
        }
    };
    for (const record of combined) {
        if (record.kind === 'view-header' || record.kind === 'named-record') {
            flushCurrentGroup(record.offset);
            currentHeaderKind = record.kind;
            currentHeaderName = record.name;
            currentHeaderOffset = record.offset;
            currentBodyPinCount = 0;
            currentBodyDirectedPins = 0;
            currentBodyDirectionlessPins = 0;
            currentBodyHasPowerPin = false;
            continue;
        }
        if (currentHeaderKind && record.kind === 'symbol-pin') {
            currentBodyPinCount++;
            currentBodyHasPowerPin =
                currentBodyHasPowerPin || record.pinType === OrcadDsnCfbTypes_1.OrcadDsnCfbTypes.OrCadDsnCfbSymbolPinType.Power;
            if (record.pinDisplayFlags === undefined) {
                continue;
            }
            if (isDirectedSymbolPin(record.pinDisplayFlags)) {
                currentBodyDirectedPins++;
            }
            else {
                currentBodyDirectionlessPins++;
            }
        }
    }
    flushCurrentGroup(cacheEntry.content.length);
    for (const packageName of packageNames) {
        namedRecordEvidence.delete(packageName);
    }
    return namedRecordEvidence;
}
function isDirectedSymbolPin(displayFlags) {
    if (displayFlags === undefined) {
        return false;
    }
    const directed = OrcadDsnCfbTypes_1.OrcadDsnCfbTypes.OrCadDsnCfbSymbolPinDisplayFlag.IsLeftPointing |
        OrcadDsnCfbTypes_1.OrcadDsnCfbTypes.OrCadDsnCfbSymbolPinDisplayFlag.IsRightPointing;
    return (displayFlags & directed) !== 0;
}
function libraryStringCatalogFromExtra(extra) {
    const catalog = extra?.libraryStringCatalog;
    return Array.isArray(catalog) && catalog.every((value) => typeof value === 'string') ? catalog : undefined;
}
function extraWithoutLibraryStringCatalog(extra) {
    return Object.fromEntries(Object.entries(extra ?? {}).filter(([key]) => key !== 'libraryStringCatalog'));
}
function parseOrCadDsnCfb(fileContents, options = {}) {
    const entries = (0, OrcadDsnCfbCfb_1.readOrCadDsnCfbEntries)(fileContents);
    const libraryEntries = entries.filter((entry) => entry.path === 'Root Entry/Library' && entry.type === 2);
    const libraryBytes = libraryEntries.length === 1 ? libraryEntries[0].content : undefined;
    const decodedLibraryStringCatalog = libraryBytes ? OrcadDsnCfbStreamUtils_1.OrcadDsnCfbStreamUtils.extractLibraryStringCatalog(libraryBytes) : undefined;
    const libraryStringCatalog = decodedLibraryStringCatalog ?? libraryStringCatalogFromExtra(options.extra);
    const pageStreamNames = new Set(entries.filter((entry) => /^Root Entry\/Views\/[^/]+\/Pages\/[^/]+$/.test(entry.path)).map((entry) => entry.path));
    const roleDiagnostics = [];
    if (libraryBytes !== undefined && decodedLibraryStringCatalog === undefined) {
        roleDiagnostics.push({
            severity: 'warning',
            code: 'library-string-catalog-withheld',
            streamPath: 'Root Entry/Library',
            message: 'CFB Library string catalogue does not form a complete counted-string table',
        });
    }
    const knownSpecialSymbols = collectKnownSpecialCacheSymbolNames(entries, roleDiagnostics);
    const resolvedOptions = {
        maxDiagnosticAsciiRunsPerStream: options.maxDiagnosticAsciiRunsPerStream ?? 200,
        minDiagnosticAsciiRunLength: options.minDiagnosticAsciiRunLength ?? 4,
        includeDiagnostics: options.includeDiagnostics ?? false,
        includeRawRecords: options.includeRawRecords ?? false,
        diagnosticMode: options.diagnosticMode ?? 'summary',
        extra: {
            ...extraWithoutLibraryStringCatalog(options.extra),
            knownSpecialSymbols,
            roleDiagnostics,
        },
    };
    const streams = entries
        .map((entry) => (0, OrcadDsnCfbStreamParsing_1.summarizeOrCadDsnCfbStream)(entry, pageStreamNames, resolvedOptions, libraryStringCatalog))
        .filter((entry) => Boolean(entry));
    const hierarchyOccurrenceTrust = (0, OrcadDsnCfbOccurrenceOwnership_1.readHierarchyOccurrenceTrust)({ streams });
    const document = (0, OrcadDsnCfbMaterializer_1.materializeOrCadDsnCfbDocument)(entries, streams, hierarchyOccurrenceTrust);
    return roleDiagnostics.length > 0 ?
        { ...document, diagnostics: [...(document.diagnostics ?? []), ...roleDiagnostics] }
        : document;
}
//# sourceMappingURL=OrcadDsnCfbParser.js.map